export default {
  "zh-CN": {
    home: "首页",
    research: "科研中心",
    product: "业务板块",
    forward: "前沿观察",
    news: "新闻动态",
    about: "关于我们",
    join: "加入我们",
    dataCenter: "大数据研究中心",
    drive: "智能驾驶研究中心",
    artificial: "人工智能研究中心",
    perception: "智能感知研究中心（筹）",
    interOfThing: "物联网与大数据实验室",
    blockchain: "区块链与大数据实验室",
    traffic: "交通大数据分析及应用实验室",
    meteorological: "时空大数据与人工智能实验室",
    digitalTwin: "数字孪生实验室",
    znjsBigData: "智能驾驶与大数据实验室",
    medicalCare: "医疗大数据与人工智能实验室",
    intelligence: "智能互联与计算机联合研究实验室",
    dataReport: "数据报告",
    achievements: "科研成果",
    patent: "专利申报",
    copyright: "软件著作权",
    paper: "科研论文",
    smartTransportation: "智慧交通",
    smartPark: "智慧园区",
    cityService: "智慧城市",
    salon: "科研沙龙",
    forum: "国际论坛",
    communication: "新闻动态",
    block_chain: "区块链",
    summerSchool: "暑假学校",
    salon2020: "2020科研沙龙系列",
    forum2018: "2018年创赛与论坛",
    forum2019: "2019年论坛",
    cs2019: "2019年创赛",
    brief: "研究院简介",
    introduce: "科研中心",
    contact: "联系方式",
    technology: "技术类",
    administration: "管理类",
    d1: "科研部",
    t1: "实验部",
    b1: "业务部-开发交付组",
    b2: "业务部-大数据应用创新应用中心",
    c1: "综合部",
    b: "业务部",
		field: "研究中心简介",
		laboratory: "实验室"
  },
  "en": {
    home: "Home",
    research: "Research Centers",
    product: "Industry Practice",
    forward: "Forward",
    news: "Events",
    about: "About Us",
    join: "Join Us",
		dataCenter: "Big Data",
		drive: "Autonomous Driving",
		artificial: "Artificial Intelligence",
		perception: "Intelligence Recognition(coming soon)",
		interOfThing: "IoT and Big Data Lab",
		blockchain: "Blockchain and Big Data Lab",
		traffic: "Traffic Big Data Analysis and Application Lab",
		meteorological: "Spatiotemporal Big Data and AI Lab",
		digitalTwin: "Digital Twin Lab",
    znjsBigData: "Autonomous Driving and Big Data Lab",
		medicalCare: "Medical Big Data and AI Lab",
		intelligence: "智能互联与计算机联合研究实验室",
		dataReport: "数据报告",
		achievements: "科研成果",
		patent: "专利申报",
		copyright: "软件著作权",
		paper: "科研论文",
		smartTransportation: "Smart Transportation",
		smartPark: "Smart Park",
		cityService: "Smart City",
		salon: "Research Workshop",
		forum: "International Forum",
		communication: "Collaboration",
		block_chain: "Blockchain Seminar",
		summerSchool: "暑假学校",
		salon2020: "Research Workshop Series 2020",
    forum2018: "2018 Forum and Contest",
    forum2019: "2019 Forum and Contest",
    cs2019: "Contest 2019",
		brief: "Who We Are",
		introduce: "Research Centers",
		contact: "Contact Us",
		technology: "技术类",
		administration: "管理类",
		d1: "科研部",
		t1: "实验部",
		b1: "业务部-开发交付组",
		b2: "业务部-大数据应用创新应用中心",
		c1: "综合部",
		b: "业务部",
		field: "Introduction",
		laboratory: "Laboratory"
  }
}